<app-modal header="core.license.title" [hasFooter]="false" [closable]="true" (closed)="close()">
  <div body>
    <app-table
      translationGroup="core.license"
      [columns]="columns"
      [loading]="false"
      [rows]="rows"
      [options]="tableOptions"
      identifier="tableLicenseAttribution">
      <ng-template cellTemplate="nameTemplate" let-row>
        <a [href]="row.homepage ?? row.repository" target="_blank">{{ row.name }}</a>
      </ng-template>
      <ng-template cellTemplate="linksTemplate" let-row>
        <div class="d-flex flex-column align-items-start gap-1">
          @if (row?.homepage?.length) {
            <a target="_blank" href="{{ row.homepage }}">{{ row.homepage }}</a>
          }
          @if (row?.repository?.length) {
            <a target="_blank" href="{{ row.repository }}">{{ row.repository }}</a>
          }
        </div>
      </ng-template>
    </app-table>
  </div>
</app-modal>
